import MembershipRole from "~/lib/organizations/types/membership-role";

/**
 * User Roles
 *
 * Here is where you can edit the user roles in your application according
 * to your application's domain.
 *
 * For example, you could add a role named
 * "Account Manager":
 * 1. extend the enum {@link MembershipRole}
 * 2. add the text strings
 * 3. apply any needed change to ~/lib/permissions.ts
 * 4. add a new model below, so you can display the correct data in the
 * selector component {@link MembershipRoleSelector}
 */

const OWNER = {
  label: "Owner",
  description: "Can change any setting, invite new members and manage billing",
  value: MembershipRole.Owner,
};

const ADMIN = {
  label: "Admin",
  description:
    "Can change some settings, invite members, perform disruptive actions",
  value: MembershipRole.Admin,
};

const MEMBER = {
  label: "Member",
  description: "Cannot invite members or change settings",
  value: MembershipRole.Member,
};

const roles = [OWNER, ADMIN, MEMBER];

export default roles;
